import { MDSIconButton, MDSIconButtonSize, MDSIconButtonVariant } from "@/mds/components/buttons";
import { MDSIconKind } from "@/mds/components/icon";
import {
  StyledSectionHeaderContainer,
  StyledSectionItemContainerLeft,
  StyledSectionItemContainerRight,
} from "@/components/layout/components/sidebar/sidebar-section/sidebar-section.styles";
import { SidebarSectionHeaderSlotName } from "@/components/layout/components/sidebar/sidebar-section/sidebar-section.types";
import { MDSText, MDSTextColor, MDSTextVariant, MDSTextWeight } from "@/mds/components/text";
import { getSlot } from "@/mds/utils/slots";
import styled from "@emotion/styled";
import { ReactNode, useState } from "react";
import { ButtonProps } from "react-aria-components";

interface SidebarSectionHeaderProps extends Exclude<ButtonProps, "children"> {
  defaultIconKind: MDSIconKind;
  label: string;
  children?: ReactNode;
  isExpanded: boolean;
  isDisabled?: boolean;
}

export const SidebarSectionHeader = ({
  defaultIconKind,
  label,
  isExpanded,
  ...props
}: SidebarSectionHeaderProps) => {
  const rightButtons = getSlot(props.children, SidebarSectionHeaderSlotName.ButtonsRight);
  const [isHovered, setIsHovered] = useState(false);
  const iconKind = isExpanded
    ? MDSIconKind.CaretDown
    : isHovered
      ? MDSIconKind.CaretRight
      : defaultIconKind;

  return (
    <StyledSectionHeaderContainer
      onHoverStart={() => setIsHovered(true)}
      onHoverEnd={() => setIsHovered(false)}
      {...props}
    >
      <StyledSectionItemContainerLeft>
        <StyledSectionHeaderIconButton
          size={MDSIconButtonSize.XSmall}
          variant={MDSIconButtonVariant.OnChrome}
          iconKind={iconKind}
          onPress={props.onPress}
          rounded
        />
        <MDSText
          variant={MDSTextVariant.TextXs}
          weight={MDSTextWeight.SemiBold}
          color={MDSTextColor.Secondary}
        >
          {label}
        </MDSText>
      </StyledSectionItemContainerLeft>
      {rightButtons && (
        <StyledSectionItemContainerRight data-right-buttons>
          {rightButtons}
        </StyledSectionItemContainerRight>
      )}
    </StyledSectionHeaderContainer>
  );
};

const StyledSectionHeaderIconButton = styled(MDSIconButton)`
  & .mds-icon {
    font-size: 12px;
    height: 12px;
    width: 12px;
  }
`;
